import React from "react"

const Policies = ({ staticTexts: text = {}, config = {} }) => {
  const { legalPageData: { map: links = {} } = {} } = config

  return (
    <ul className="pdp-policies pdp-additional-info">
      <li>
        <h5 className="pdp-spec-detail__title">{text.returnTitle}</h5>
        <p className="pdp-features-technologies__list-item">
          {text.returnDesc}
        </p>
        <a
          className="pdp-spec-detail__title"
          href={links.returnPolicy ?? "#"}
          target="_blank"
          rel="noreferrer"
        >
          {text.findMore}
        </a>
      </li>
      <li>
        <h5 className="pdp-spec-detail__title">{text.warrantyTitle}</h5>
        <p className="pdp-features-technologies__list-item">
          {text.warrantyDesc}
        </p>
        <a
          className="pdp-spec-detail__title"
          href={links.productWarranty ?? "#"}
          target="_blank"
          rel="noreferrer"
        >
          {text.findMore}
        </a>
      </li>
    </ul>
  )
}

export default Policies
